import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import ViewListIcon from "@material-ui/icons/ViewList";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Fade from "@material-ui/core/Fade";
import TableContainer from "@material-ui/core/TableContainer";
import Chip from "@material-ui/core/Chip";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

// Imports do MUI v5 para o novo layout
import { Box as BoxV5, Container } from "@mui/material";
import { Paper as PaperV5 } from "@mui/material";
import { Avatar as AvatarV5 } from "@mui/material";
import { Typography as TypographyV5 } from "@mui/material";
import { Stack } from "@mui/material";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from "../../utils/formatSerializedId";
import { v4 as uuidv4 } from "uuid";

import { ArrowDropDown, Backup, ContactPhone } from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

// ================= GEO / DDD CONFIG DO MAPA =================

const geoUrl =
  "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const markers = [
  { markerOffset: -30, name: "Aracaju", coordinates: [-37.0717, -10.9472] },
  { markerOffset: 15, name: "Belém", coordinates: [-48.4878, -1.4558] },
  { markerOffset: 15, name: "Belo Horizonte", coordinates: [-43.9378, -19.8157] },
  { markerOffset: 15, name: "Boa Vista", coordinates: [-60.6739, 2.8195] },
  { markerOffset: 15, name: "Brasília", coordinates: [-47.8825, -15.7942] },
  { markerOffset: 15, name: "Campo Grande", coordinates: [-54.6464, -20.4428] },
  { markerOffset: 15, name: "Cuiabá", coordinates: [-56.0969, -15.6011] },
  { markerOffset: 15, name: "Curitiba", coordinates: [-49.2736, -25.4296] },
  { markerOffset: 15, name: "Florianópolis", coordinates: [-48.5492, -27.5969] },
  { markerOffset: 15, name: "Fortaleza", coordinates: [-38.5267, -3.71839] },
  { markerOffset: 15, name: "Goiânia", coordinates: [-49.2736, -16.6869] },
  { markerOffset: 15, name: "João Pessoa", coordinates: [-34.8631, -7.1195] },
  { markerOffset: 15, name: "Macapá", coordinates: [-51.0667, 0.0333] },
  { markerOffset: 15, name: "Maceió", coordinates: [-35.7353, -9.6658] },
  { markerOffset: 15, name: "Manaus", coordinates: [-60.025, -3.10194] },
  { markerOffset: 15, name: "Natal", coordinates: [-35.2094, -5.795] },
  { markerOffset: 15, name: "Palmas", coordinates: [-48.3347, -10.1844] },
  { markerOffset: 15, name: "Porto Alegre", coordinates: [-51.23, -30.0331] },
  { markerOffset: 15, name: "Porto Velho", coordinates: [-63.9039, -8.7619] },
  { markerOffset: 15, name: "Recife", coordinates: [-34.8811, -8.05389] },
  { markerOffset: 15, name: "Rio Branco", coordinates: [-67.8099, -9.9747] },
  { markerOffset: 15, name: "Rio de Janeiro", coordinates: [-43.1729, -22.9068] },
  { markerOffset: 15, name: "Salvador", coordinates: [-38.4813, -12.9716] },
  { markerOffset: 15, name: "São Luís", coordinates: [-44.3028, -2.5283] },
  { markerOffset: 15, name: "São Paulo", coordinates: [-46.6333, -23.5505] },
  { markerOffset: 15, name: "Teresina", coordinates: [-42.8039, -5.0892] },
  { markerOffset: 15, name: "Vitória", coordinates: [-40.3378, -20.3194] },
];

const dddList = {
  "11": "São Paulo", "12": "São Paulo", "13": "São Paulo", "14": "São Paulo",
  "15": "São Paulo", "16": "São Paulo", "17": "São Paulo", "18": "São Paulo",
  "19": "São Paulo", "21": "Rio de Janeiro", "22": "Rio de Janeiro",
  "24": "Rio de Janeiro", "27": "Espírito Santo", "28": "Espírito Santo",
  "31": "Minas Gerais", "32": "Minas Gerais", "33": "Minas Gerais",
  "34": "Minas Gerais", "35": "Minas Gerais", "37": "Minas Gerais",
  "38": "Minas Gerais", "41": "Paraná", "42": "Paraná", "43": "Paraná",
  "44": "Paraná", "45": "Paraná", "46": "Paraná", "47": "Santa Catarina",
  "48": "Santa Catarina", "49": "Santa Catarina", "51": "Rio Grande do Sul",
  "53": "Rio Grande do Sul", "54": "Rio Grande do Sul", "55": "Rio Grande do Sul",
  "61": "Distrito Federal/Goiás", "62": "Goiás", "63": "Tocantins",
  "64": "Goiás", "65": "Mato Grosso", "66": "Mato Grosso",
  "67": "Mato Grosso do Sul", "68": "Acre", "69": "Rondônia", "71": "Bahia",
  "73": "Bahia", "74": "Bahia", "75": "Bahia", "77": "Bahia", "79": "Sergipe",
  "81": "Pernambuco", "82": "Alagoas", "83": "Paraíba",
  "84": "Rio Grande do Norte", "85": "Ceará", "86": "Piauí",
  "87": "Pernambuco", "88": "Ceará", "89": "Piauí", "91": "Pará",
  "92": "Amazonas", "93": "Pará", "94": "Pará", "95": "Roraima",
  "96": "Amapá", "97": "Amazonas", "98": "Maranhão", "99": "Maranhão",
};

// ================= REDUCER =================

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    const contacts = action.payload;
    const newContacts = [];

    contacts.forEach((contact) => {
      const contactIndex = state.findIndex((c) => c.id === contact.id);
      if (contactIndex !== -1) {
        state[contactIndex] = contact;
      } else {
        newContacts.push(contact);
      }
    });

    return [...state, ...newContacts];
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    } else {
      return [contact, ...state];
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  legendCard: {
    marginBottom: 20,
    padding: 10,
    backgroundColor: "#fff",
    borderRadius: 12,
    border: "1px solid",
    borderColor: theme.palette.divider,
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
  },
  legendContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    margin: "5px 10px",
  },
  legendColor: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    marginRight: 5,
    backgroundColor: "#FFA500",
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();

  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [viewMode, setViewMode] = useState("cards"); // cards ou list

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);

  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const { setCurrentTicket } = useContext(TicketsContext);

  const [importWhatsappId, setImportWhatsappId] = useState();

  // SELEÇÃO EM MASSA
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [confirmDeleteManyOpen, setConfirmDeleteManyOpen] = useState(false);

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);

  // CONTROLE DE ABAS (CONTATOS / MAPA)
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleViewModeChange = (event, newMode) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);
      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
    setSelectedContactIds([]);
    setIsSelectAllChecked(false);
  }, [searchParam, selectedTags]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: {
              searchParam,
              pageNumber,
              contactTag: JSON.stringify(selectedTags),
            },
          });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setHasMore(data.hasMore);
          setLoading(false);

          const allCurrentContactIds = data.contacts.map((c) => c.id);
          const newSelected = selectedContactIds.filter((id) =>
            allCurrentContactIds.includes(id)
          );
          setSelectedContactIds(newSelected);
          setIsSelectAllChecked(
            newSelected.length === allCurrentContactIds.length &&
              allCurrentContactIds.length > 0
          );
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, selectedTags]);

  useEffect(() => {
    const companyId = user.companyId;
    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        setSelectedContactIds((prevSelected) =>
          prevSelected.filter((id) => id !== +data.contactId)
        );
      }
    };
    socket.on(`company-${companyId}-contact`, onContactEvent);

    return () => {
      socket.off(`company-${companyId}-contact`, onContactEvent);
    };
  }, [socket, user.companyId]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
  };

  const handleToggleSelectContact = (contactId) => (event) => {
    if (event.target.checked) {
      setSelectedContactIds((prevSelected) => [...prevSelected, contactId]);
    } else {
      setSelectedContactIds((prevSelected) =>
        prevSelected.filter((id) => id !== contactId)
      );
      setIsSelectAllChecked(false);
    }
  };

  const handleSelectAllContacts = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      const allContactIds = contacts.map((contact) => contact.id);
      setSelectedContactIds(allContactIds);
    } else {
      setSelectedContactIds([]);
    }
  };

  const handleDeleteSelectedContacts = async () => {
    try {
      setLoading(true);
      await api.delete("/contacts/batch-delete", {
        data: { contactIds: selectedContactIds },
      });
      toast.success("Contatos selecionados deletados com sucesso!");
      setSelectedContactIds([]);
      setIsSelectAllChecked(false);
      setConfirmDeleteManyOpen(false);
      dispatch({ type: "RESET" });
      setPageNumber(1);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      dispatch({
        type: "UPDATE_CONTACTS",
        payload: { ...blockingContact, active: false },
      });
      toast.success("Contato bloqueado");
    } catch (err) {
      toastError(err);
    }
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      dispatch({
        type: "UPDATE_CONTACTS",
        payload: { ...unBlockingContact, active: true },
      });
      toast.success("Contato desbloqueado");
    } catch (err) {
      toastError(err);
    }
    setUnBlockingContact(null);
  };

  const onSave = (whatsappId) => {
    setImportWhatsappId(whatsappId);
  };

  const handleimportContact = async () => {
    setImportContactModalOpen(false);

    try {
      await api.post("/contacts/import", { whatsappId: importWhatsappId });
      history.go(0);
      setImportContactModalOpen(false);
    } catch (err) {
      toastError(err);
      setImportContactModalOpen(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const countContactsByState = () => {
    const stateCounts = {};

    contacts.forEach((contact) => {
      const number = contact.number;
      if (number && number.length > 4) {
        const ddd = number.substring(2, 4);
        if (dddList[ddd]) {
          const state = dddList[ddd];
          if (!stateCounts[state]) {
            stateCounts[state] = 0;
          }
          stateCounts[state]++;
        } else {
          if (!stateCounts["Outros"]) {
            stateCounts["Outros"] = 0;
          }
          stateCounts["Outros"]++;
        }
      }
    });

    return stateCounts;
  };

  const stateCounts = countContactsByState();

  const PRIMARY_MAIN = theme?.palette?.primary?.main || "#1976d2";
  const PRIMARY_DARK = theme?.palette?.primary?.dark || "#115293";

  return (
    <BoxV5
      sx={{
        minHeight: "100vh",
        py: { xs: 3, md: 4 },
        px: { xs: 2, md: 3 },
        bgcolor: "#f8fafc"
      }}
    >
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>

      <ConfirmationModal
        title={
          deletingContact
            ? `${i18n.t("contacts.confirmationModal.deleteTitle")} ${deletingContact.name}?`
            : blockingContact
            ? `Bloquear Contato ${blockingContact.name}?`
            : unBlockingContact
            ? `Desbloquear Contato ${unBlockingContact.name}?`
            : ImportContacts
            ? `${i18n.t("contacts.confirmationModal.importTitlte")}`
            : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
        }
        onSave={onSave}
        isCellPhone={ImportContacts}
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={(e) =>
          deletingContact
            ? handleDeleteContact(deletingContact.id)
            : blockingContact
            ? handleBlockContact(blockingContact.id)
            : unBlockingContact
            ? handleUnBlockContact(unBlockingContact.id)
            : ImportContacts
            ? handleimportContact()
            : handleImportExcel()
        }
      >
        {exportContact
          ? `${i18n.t("contacts.confirmationModal.exportContact")}`
          : deletingContact
          ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
          : blockingContact
          ? `${i18n.t("contacts.confirmationModal.blockContact")}`
          : unBlockingContact
          ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
          : ImportContacts
          ? `Escolha de qual conexão deseja importar`
          : `${i18n.t("contactListItems.confirmationModal.importMessage")}`}
      </ConfirmationModal>

      <ConfirmationModal
        title={`Tem certeza que deseja deletar ${selectedContactIds.length} contatos selecionados?`}
        open={confirmDeleteManyOpen}
        onClose={() => setConfirmDeleteManyOpen(false)}
        onConfirm={handleDeleteSelectedContacts}
      >
        Essa ação é irreversível.
      </ConfirmationModal>

      <ConfirmationModal
        title={i18n.t("contacts.confirmationModal.importChat")}
        open={confirmChatsOpen}
        onClose={setConfirmChatsOpen}
        onConfirm={(e) => handleimportChats()}
      >
        {i18n.t("contacts.confirmationModal.wantImport")}
      </ConfirmationModal>

      <Container maxWidth="xl">
        {/* Header */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
          spacing={3}
          sx={{ mb: 4 }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <AvatarV5
              sx={{
                width: 48,
                height: 48,
                borderRadius: 3,
                bgcolor: PRIMARY_MAIN,
                "& svg": { width: 28, height: 28, color: "#fff" },
              }}
            >
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </AvatarV5>
            <BoxV5>
              <TypographyV5
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: "text.primary",
                  mb: 0.5,
                  letterSpacing: "-0.5px",
                  fontSize: { xs: "1.5rem", md: "1.875rem" },
                }}
              >
                {i18n.t("contacts.title")} ({contacts.length})
              </TypographyV5>
              <TypographyV5
                variant="body2"
                sx={{ color: "text.secondary", fontWeight: 500, fontSize: "0.875rem" }}
              >
                Gerencie seus contatos
              </TypographyV5>
            </BoxV5>
          </Stack>

          <Stack direction="row" spacing={2} flexWrap="wrap" alignItems="center">
            <TagsFilter onFiltered={handleSelectedTags} />
            <TextField
              placeholder={i18n.t("contacts.searchPlaceholder")}
              type="search"
              value={searchParam}
              onChange={handleSearch}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
              style={{ minWidth: 200 }}
            />
            <PopupState variant="popover" popupId="demo-popup-menu">
              {(popupState) => (
                <React.Fragment>
                  <Button
                    variant="contained"
                    color="primary"
                    {...bindTrigger(popupState)}
                  >
                    Importar/Exportar
                    <ArrowDropDown />
                  </Button>
                  <Menu {...bindMenu(popupState)}>
                    <MenuItem
                      onClick={() => {
                        setConfirmOpen(true);
                        setImportContacts(true);
                        popupState.close();
                      }}
                    >
                      <ContactPhone fontSize="small" color="primary" style={{ marginRight: 10 }} />
                      {i18n.t("contacts.menu.importYourPhone")}
                    </MenuItem>
                    <MenuItem onClick={() => { setImportContactModalOpen(true); }}>
                      <Backup fontSize="small" color="primary" style={{ marginRight: 10 }} />
                      {i18n.t("contacts.menu.importToExcel")}
                    </MenuItem>
                  </Menu>
                </React.Fragment>
              )}
            </PopupState>

            <Button
              variant="contained"
              onClick={() => setConfirmDeleteManyOpen(true)}
              disabled={selectedContactIds.length === 0 || loading}
              style={{ backgroundColor: "#ef4444", color: "white" }}
            >
              Deletar ({selectedContactIds.length})
            </Button>

            <Button variant="contained" color="primary" onClick={handleOpenContactModal}>
              {i18n.t("contacts.buttons.add")}
            </Button>
          </Stack>
        </Stack>

        {importContactModalOpen && (
          <ContactImportWpModal
            isOpen={importContactModalOpen}
            handleClose={() => setImportContactModalOpen(false)}
            selectedTags={selectedTags}
            hideNum={hideNum}
            userProfile={user.profile}
          />
        )}

        {/* ABAS */}
        <PaperV5
          elevation={0}
          sx={{
            mb: 3,
            borderRadius: 3,
            bgcolor: "#fff",
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            p: 1,
            display: "inline-flex",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                fontWeight: 700,
                textTransform: "none",
                fontSize: "0.875rem",
                minHeight: 48,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                color: "text.secondary",
                transition: "all 0.3s ease",
                "&.Mui-selected": {
                  color: "#fff",
                  bgcolor: PRIMARY_MAIN,
                },
                "&:hover:not(.Mui-selected)": { bgcolor: "action.hover" },
              },
            }}
          >
            <Tab label="Contatos" iconPosition="start" />
            <Tab label="Mapa" iconPosition="start" />
          </Tabs>
        </PaperV5>

        <BoxV5>
          <input
            style={{ display: "none" }}
            id="upload"
            name="file"
            type="file"
            accept=".xls,.xlsx"
            onChange={() => { setConfirmOpen(true); }}
            ref={fileUploadRef}
          />

          {/* ABA CONTATOS */}
          {tabValue === 0 && (
            <Fade in={true} timeout={500}>
              <PaperV5
                elevation={0}
                sx={{
                  borderRadius: 3,
                  bgcolor: "#fff",
                  border: "1px solid",
                  borderColor: "divider",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  overflow: "hidden"
                }}
              >
                <Box sx={{ p: 3, borderBottom: "1px solid", borderColor: "divider" }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" style={{ fontWeight: 700, fontSize: "1.125rem" }}>
                      Lista de Contatos
                    </Typography>
                    <ToggleButtonGroup
                      value={viewMode}
                      exclusive
                      onChange={handleViewModeChange}
                      size="small"
                    >
                      <ToggleButton value="cards">
                        <ViewModuleIcon fontSize="small" />
                      </ToggleButton>
                      <ToggleButton value="list">
                        <ViewListIcon fontSize="small" />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Stack>
                </Box>

                <Box sx={{ p: 3 }}>
                  <Box display="flex" alignItems="center" style={{ marginBottom: 24 }}>
                    <Checkbox
                      checked={isSelectAllChecked}
                      onChange={handleSelectAllContacts}
                      color="primary"
                    />
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.875rem" }}>
                      Selecionar todos os contatos
                    </Typography>
                  </Box>

                  {/* VISUALIZAÇÃO EM CARDS */}
                  {viewMode === "cards" && (
                    <Grid container spacing={2.5}>
                      {contacts.map((contact) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={contact.id}>
                          <Card
                            sx={{
                              borderRadius: 2,
                              border: "1px solid",
                              borderColor: "divider",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                              transition: "all 0.2s",
                              "&:hover": {
                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                transform: "translateY(-2px)",
                              },
                            }}
                          >
                            <CardContent style={{ padding: 20 }}>
                              <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 2 }}>
                                <Stack direction="row" spacing={1.5} alignItems="center">
                                  <Avatar
                                    src={`${contact?.urlPicture}`}
                                    sx={{ width: 48, height: 48, border: "1.5px solid", borderColor: "divider" }}
                                  />
                                  <Box>
                                    <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: "0.875rem" }}>
                                      {contact.name || "-"}
                                    </Typography>
                                    <Typography variant="caption" style={{ color: theme.palette.text.secondary, fontSize: "0.75rem" }}>
                                      {enableLGPD && hideNum && user.profile === "user"
                                        ? contact.isGroup
                                          ? contact.number
                                          : formatSerializedId(contact?.number) === null
                                          ? contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2)
                                          : formatSerializedId(contact?.number)?.slice(0, -6) + "**-**" + contact?.number?.slice(-2)
                                        : contact.isGroup
                                        ? contact.number
                                        : formatSerializedId(contact?.number)}
                                    </Typography>
                                  </Box>
                                </Stack>
                                <Checkbox
                                  checked={selectedContactIds.includes(contact.id)}
                                  onChange={handleToggleSelectContact(contact.id)}
                                  color="primary"
                                  size="small"
                                />
                              </Stack>

                              {contact.email && (
                                <Typography variant="caption" style={{ color: theme.palette.text.secondary, display: "block", mb: 0.5 }}>
                                  {contact.email}
                                </Typography>
                              )}

                              <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 1.5 }}>
                                <Chip
                                  icon={contact.active ? <CheckCircleIcon style={{ fontSize: 14 }} /> : <CancelIcon style={{ fontSize: 14 }} />}
                                  label={contact.active ? "Ativo" : "Bloqueado"}
                                  size="small"
                                  sx={{
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    bgcolor: contact.active ? "rgba(16, 185, 129, 0.1)" : "rgba(239, 68, 68, 0.1)",
                                    color: contact.active ? "#10b981" : "#ef4444",
                                    border: "1px solid",
                                    borderColor: contact.active ? "rgba(16, 185, 129, 0.2)" : "rgba(239, 68, 68, 0.2)",
                                  }}
                                />
                              </Stack>

                              <Stack direction="row" spacing={0.5} justifyContent="flex-end" sx={{ mt: 2 }}>
                                <IconButton
                                  size="small"
                                  disabled={!contact.active}
                                  onClick={() => {
                                    setContactTicket(contact);
                                    setNewTicketModalOpen(true);
                                  }}
                                  style={{ color: contact.active ? "#10b981" : "gray" }}
                                >
                                  {contact.channel === "whatsapp" && <WhatsApp style={{ fontSize: 18 }} />}
                                  {contact.channel === "instagram" && <Instagram style={{ fontSize: 18 }} />}
                                  {contact.channel === "facebook" && <Facebook style={{ fontSize: 18 }} />}
                                </IconButton>

                                <IconButton
                                  size="small"
                                  title={i18n.t("importantClientNotes.widget.title")}
                                  onClick={() => history.push(`/important-client-notes?contactId=${contact.id}`)}
                                  style={{ color: "#6366f1" }}
                                >
                                  <AssignmentIcon style={{ fontSize: 18 }} />
                                </IconButton>

                                <IconButton
                                  size="small"
                                  onClick={() => hadleEditContact(contact.id)}
                                  style={{ color: PRIMARY_MAIN }}
                                >
                                  <EditIcon style={{ fontSize: 18 }} />
                                </IconButton>

                                <IconButton
                                  size="small"
                                  onClick={
                                    contact.active
                                      ? () => { setConfirmOpen(true); setBlockingContact(contact); }
                                      : () => { setConfirmOpen(true); setUnBlockingContact(contact); }
                                  }
                                  style={{ color: "#f59e0b" }}
                                >
                                  {contact.active ? <BlockIcon style={{ fontSize: 18 }} /> : <CheckCircleIcon style={{ fontSize: 18 }} />}
                                </IconButton>

                                <Can
                                  role={user.profile}
                                  perform="contacts-page:deleteContact"
                                  yes={() => (
                                    <IconButton
                                      size="small"
                                      onClick={(e) => { setConfirmOpen(true); setDeletingContact(contact); }}
                                      style={{ color: "#ef4444" }}
                                    >
                                      <DeleteOutlineIcon style={{ fontSize: 18 }} />
                                    </IconButton>
                                  )}
                                />
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  )}

                  {/* VISUALIZAÇÃO EM LISTA */}
                  {viewMode === "list" && (
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox checked={isSelectAllChecked} onChange={handleSelectAllContacts} color="primary" />
                            </TableCell>
                            <TableCell style={{ fontWeight: 600, fontSize: "0.7rem", textTransform: "uppercase", color: theme.palette.text.secondary }}>Nome</TableCell>
                            <TableCell style={{ fontWeight: 600, fontSize: "0.7rem", textTransform: "uppercase", color: theme.palette.text.secondary }}>Número</TableCell>
                            <TableCell style={{ fontWeight: 600, fontSize: "0.7rem", textTransform: "uppercase", color: theme.palette.text.secondary }}>Email</TableCell>
                            <TableCell style={{ fontWeight: 600, fontSize: "0.7rem", textTransform: "uppercase", color: theme.palette.text.secondary }}>Status</TableCell>
                            <TableCell align="center" style={{ fontWeight: 600, fontSize: "0.7rem", textTransform: "uppercase", color: theme.palette.text.secondary }}>Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {contacts.map((contact) => (
                            <TableRow
                              key={contact.id}
                              sx={{
                                "&:hover": { bgcolor: "action.hover", transition: "background-color 0.2s" }
                              }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox checked={selectedContactIds.includes(contact.id)} onChange={handleToggleSelectContact(contact.id)} color="primary" />
                              </TableCell>
                              <TableCell>
                                <Stack direction="row" spacing={1.5} alignItems="center">
                                  <Avatar src={`${contact?.urlPicture}`} sx={{ width: 36, height: 36 }} />
                                  <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.875rem" }}>
                                    {contact.name || "-"}
                                  </Typography>
                                </Stack>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" style={{ fontSize: "0.875rem" }}>
                                  {enableLGPD && hideNum && user.profile === "user"
                                    ? contact.isGroup
                                      ? contact.number
                                      : formatSerializedId(contact?.number) === null
                                      ? contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2)
                                      : formatSerializedId(contact?.number)?.slice(0, -6) + "**-**" + contact?.number?.slice(-2)
                                    : contact.isGroup
                                    ? contact.number
                                    : formatSerializedId(contact?.number)}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" style={{ fontSize: "0.875rem" }}>
                                  {contact.email || "-"}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Chip
                                  icon={contact.active ? <CheckCircleIcon style={{ fontSize: 14 }} /> : <CancelIcon style={{ fontSize: 14 }} />}
                                  label={contact.active ? "Ativo" : "Bloqueado"}
                                  size="small"
                                  sx={{
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    bgcolor: contact.active ? "rgba(16, 185, 129, 0.1)" : "rgba(239, 68, 68, 0.1)",
                                    color: contact.active ? "#10b981" : "#ef4444",
                                    border: "1px solid",
                                    borderColor: contact.active ? "rgba(16, 185, 129, 0.2)" : "rgba(239, 68, 68, 0.2)",
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Stack direction="row" spacing={0.5} justifyContent="center">
                                  <IconButton
                                    size="small"
                                    disabled={!contact.active}
                                    onClick={() => { setContactTicket(contact); setNewTicketModalOpen(true); }}
                                    style={{ color: contact.active ? "#10b981" : "gray" }}
                                  >
                                    {contact.channel === "whatsapp" && <WhatsApp fontSize="small" />}
                                    {contact.channel === "instagram" && <Instagram fontSize="small" />}
                                    {contact.channel === "facebook" && <Facebook fontSize="small" />}
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    title={i18n.t("importantClientNotes.widget.title")}
                                    onClick={() => history.push(`/important-client-notes?contactId=${contact.id}`)}
                                    style={{ color: "#6366f1" }}
                                  >
                                    <AssignmentIcon fontSize="small" />
                                  </IconButton>

                                  <IconButton size="small" onClick={() => hadleEditContact(contact.id)} style={{ color: PRIMARY_MAIN }}>
                                    <EditIcon fontSize="small" />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    onClick={contact.active ? () => { setConfirmOpen(true); setBlockingContact(contact); } : () => { setConfirmOpen(true); setUnBlockingContact(contact); }}
                                    style={{ color: "#f59e0b" }}
                                  >
                                    {contact.active ? <BlockIcon fontSize="small" /> : <CheckCircleIcon fontSize="small" />}
                                  </IconButton>

                                  <Can
                                    role={user.profile}
                                    perform="contacts-page:deleteContact"
                                    yes={() => (
                                      <IconButton size="small" onClick={(e) => { setConfirmOpen(true); setDeletingContact(contact); }} style={{ color: "#ef4444" }}>
                                        <DeleteOutlineIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  />
                                </Stack>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}

                  {loading && (
                    <Box style={{ marginTop: 16 }}>
                      <TableRowSkeleton columns={6} />
                    </Box>
                  )}
                </Box>
              </PaperV5>
            </Fade>
          )}

          {/* ABA MAPA */}
          {tabValue === 1 && (
            <Fade in={true} timeout={500}>
              <Box>
                <PaperV5
                  elevation={0}
                  sx={{
                    mb: 3,
                    p: 2,
                    borderRadius: 3,
                    bgcolor: PRIMARY_MAIN,
                    color: "#fff",
                    textAlign: "center",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 700, fontSize: "1.125rem" }}>
                    Total de Contatos por Estado: {contacts.length}
                  </Typography>
                </PaperV5>

                <PaperV5
                  elevation={0}
                  sx={{
                    borderRadius: 3,
                    bgcolor: "#fff",
                    border: "1px solid",
                    borderColor: "divider",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                    p: 3,
                  }}
                >
                  <Card className={classes.legendCard} style={{ marginBottom: 32 }}>
                    <CardContent>
                      <Box className={classes.legendContainer}>
                        {Object.entries(stateCounts).map(([state, count]) => (
                          <Box key={state} className={classes.legendItem}>
                            <div className={classes.legendColor} />
                            <Typography variant="body2" style={{ fontWeight: 500, fontSize: "0.875rem" }}>
                              {state}: {count} contato(s)
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>

                  <ComposableMap
                    projection="geoMercator"
                    projectionConfig={{ scale: 600, center: [-53, -15] }}
                    style={{ width: "100%", height: "auto" }}
                  >
                    <Geographies geography={geoUrl}>
                      {({ geographies }) =>
                        geographies.map((geo) => {
                          const state = geo.properties.name;
                          const count = stateCounts[state] || 0;
                          return (
                            <Geography
                              key={geo.rsmKey}
                              geography={geo}
                              fill={count > 0 ? "#FFA500" : "#EAEAEC"}
                              stroke="#D6D6DA"
                              style={{ hover: { fill: "#FFA500", stroke: "#D6D6DA" } }}
                            />
                          );
                        })
                      }
                    </Geographies>
                    {markers.map(({ name, coordinates, markerOffset }) => (
                      <Marker key={name} coordinates={coordinates}>
                        <circle r={5} fill="#F00" stroke="#fff" strokeWidth={1} />
                        <text textAnchor="middle" y={markerOffset} style={{ fontFamily: "system-ui", fill: "#5D5A6D", fontSize: "12px" }}>
                          {name}
                        </text>
                      </Marker>
                    ))}
                  </ComposableMap>
                </PaperV5>
              </Box>
            </Fade>
          )}
        </BoxV5>
      </Container>
    </BoxV5>
  );
};

export default Contacts;